import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL = URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU;

const BaseMenuLink: Array<LinkItemProps> = [
  {
    name: "Center Commission Parameters",
    link: URL.CENTER_COMMISSION_PARAMETERS,
    level: 3,
  },
  {
    name: "Bank Commission Parameters",
    link: URL.BANK_COMMISSION_PARAMETERS,
    level: 3,
  },
  {
    name: "Bank Account Routing",
    link: URL.BANK_ACCOUNT_ROUTING,
    level: 3,
  },
  {
    name: "Bank Risk Management",
    link: URL.BANK_RISK_MANAGEMENT,
    level: 3,
  },
  {
    name: "Sensitive Data Parameters",
    link: URL.SENSITIVE_DATA_PARAMETERS,
    level: 3,
  },
  {
    name: "Bank Card Nbr Generation Method",
    link: URL.BANK_CARD_NUMBER_GENERATION_METHODS,
    level: 3,
  },
  {
    name: "HPX Modules Management",
    link: URL.HPX_MODULES_MANAGEMENT,
    level: 3,
  },
  {
    name: "Settlement Processing Parameter",
    link: URL.SETTLEMENT_PROCESSING_PARAMETER,
    level: 3,
  },
  {
    name: "Bank Tvr Param",
    link: URL.BANK_TERMINAL_VERIFICATION_RESULT,
    level: 3,
  },

  {
    name: "Bank Cvr Param",
    link: URL.BANK_CARD_VERIFICATION_RESULTS,
    level: 3,
  },

];

export default BaseMenuLink;
